"use client";

import { ReactNode, useEffect, useRef } from "react";
import { usePathname, useRouter } from "next/navigation";
import { onAuthStateChanged } from "firebase/auth";
import { getFirebaseAuth } from "@/lib/firebase";

export default function AuthLayout({ children }: { children: ReactNode }) {
  const router   = useRouter();
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);
  useEffect(() => { pathnameRef.current = pathname; }, [pathname]);

  useEffect(() => {
    const auth = getFirebaseAuth();
    if (!auth) return;
    const unsub = onAuthStateChanged(auth, (u) => {
      // OJO: en /join el usuario se loguea (o crea cuenta) COMO PARTE del flujo
      // de aceptar la invitación. Si lo sacáramos a /dashboard apenas se loguea,
      // interrumpiríamos ese flujo antes de que acceptInvitation resuelva (y ante
      // un rechazo por email no coincidente quedaría sin ver el error). Por eso
      // /join maneja su propia navegación.
      if (u && !pathnameRef.current.startsWith("/join")) {
        router.replace("/dashboard");
      }
    });
    return () => unsub();
  }, [router]);

  return <>{children}</>;
}
